/*
 * @Author: 史金波
 * @Date: 2021-12-15 02:15:45
 * @LastEditors: 史金波
 * @Description: 
 * @LastEditTime: 2021-12-15 15:50:07
 * @FilePath: \saas-perform-web\src\api\user\userApi.js
 */
import {httpPost,httpGet,baseUrl} from "../axiosFun.js"

export function userSearchApi(data) {
	return httpPost(baseUrl + "/user/search",data)
}

export function saveUserINfoApi(data){
  return httpPost(baseUrl+"/user/createUser",data)
}


// WEBPACK FOOTER //
// ./src/api/user/userApi.js